/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import "datatables.net-bs4";
import "datatables.net-buttons-bs4";

/*------------------------------------*\
    DOWNLOADS TABLE MODULE
\*------------------------------------*/
class DownloadsTable {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        $(document).on("ready", function () {
            var elem = $(this),
                tableElem = elem.find('.js-downloads-list__table'),
                titleColumnIndex = elem.find('.js-downloads-table__title-column').index();

            // Instantiate DataTables
            var table = tableElem.dataTable({
                order: [[titleColumnIndex, "asc"]],
                info: false,
                lengthChange: false,
                searching: false,
                pagingType: 'numbers',
                responsive: {
                    breakpoints: [
                        { name: 'xl', width: Infinity },
                        { name: 'lg', width: 1199 },
                        { name: 'md', width: 991 },
                        { name: 'sm', width: 767 },
                        { name: 'xs', width: 575 }
                    ],
                    details: false
                },
                "columnDefs": [
                    { "width": "20px", "targets": 0 },
                    { "width": "105px", "targets": 2 },
                    { "width": "30px", "targets": 3 }
                ]
            });

            table.on('page.dt', function () {
                $('html, body').animate({
                    scrollTop: tableElem.offset().top - 70
                }, 200);
            });

            // Show all
            $(".js-downloads-table__show-all").on('click', function () {
                // Show all table rows
                table.page.len(-1).draw();

                // Hide the 'show all' button
                $(this).hide();

                // Hide the pagination
                elem.find('.dataTables_paginate').hide();
            });
        });
    }
}

export default DownloadsTable;